require('./ctxSideNavigation.style.scss');
/***
 *
 * @type {angular.IModule}
 *
 * Usage Template:
 * <cpd-tabs>
 *   <cpd-tab tab-title='Books'> Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? </cpd-tab>
 *   <cpd-tab tab-title='Reviews'> At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat. </cpd-tab>
 * </cpd-tabs>
 *
 *
 */

class ctxSideNavigationController {
    constructor($scope) {
        this.tabs = [];
        this.showIcons = true;
        this.showHeadline = true;
        $scope.$watch(() => this.activeLink, activeLink => {
            (this.navLinks || []).forEach(link => delete link.active);
            if (activeLink) {
                activeLink.active = true;
            }
        });
    }

    setActive(navLink) {
        this.navLinks.forEach(link => delete link.active);
        navLink.active = true;
        this.linkAction({ link: navLink });
    }
}

ctxSideNavigationController.$inject = ['$scope'];

const ctxSideNavigationComponent = {
    controller: ctxSideNavigationController,
    template: require('./ctxSideNavigation.template.html'),
    transclude: {
        'headerSlot': 'header',
    },
    scope: {},
    bindings: {
        navLinks: '<links',
        linkAction: '&',
        activeLink: '=?ngModel',
        isCompact: '=?compact',
        hycuVersion: '@'
    }
};

module.exports = ctxSideNavigationComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxSideNavigation/ctxSideNavigation.component.js